import { Navigate, useLocation } from "react-router-dom";

import { PATHS } from "@/constants/paths";
import { useAuth } from "@/hooks/use-auth";

interface IProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute = ({ children }: IProtectedRouteProps) => {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) {
    return (
      <Navigate
        to={PATHS.AUTH.SIGN_IN}
        replace
        state={{
          from: `${location.pathname}${location.search}${location.hash}`,
        }}
      />
    );
  }

  return <>{children}</>;
};
